export default "__VITE_ASSET__BM87YkdG__"